/**
 * This is a service api to download a file from a REST API
 *
 * Uses axios to download the file and return the response data (file data) as a Blob
 * object
 */

import axios from "axios";
import Authentication from "@/store/authentication/Authentication";

export default class FileDownloadService {
	static async downloadFile(url) {
		try {
			const currUser = Authentication.findCurrentAuthentication();
			const jwt = currUser ? currUser.jwt : "";

			const jwtServiceEndpoint = {
				url: url,
				timeout: 120000, //Miliseconds
				method: "get",
				mode: "cors",
				responseType: "application/json",
				headers: { jwt: jwt, Accept: "application/json" }
			};

			let response = await axios.request(jwtServiceEndpoint);

			//The PCP Rest Services return byte arrays in the response JSON as Base64 Strings. We need to first
			//decode the base64 Stirngs into an ArrayBuffer before we set it on the Blob
			const arrayBuffer = Uint8Array.from(atob(response.data.content), c => c.charCodeAt(0));
			return new Blob([arrayBuffer.buffer], { type: response.data.contentType });
		} catch (error) {
			console.error(error); // eslint-disable-line no-console
		}
	}
}
